import rest from '../rest';
import trackingBuilder from './trackingResponse';

const tracking = [
	rest.post('https://dc.services.visualstudio.com/v2/track', (req, res, ctx) => {
		return res(ctx.json(trackingBuilder(req.body)));
	})
];

export default tracking;
